/* Mood & Life · compra rápida en tarjetas (snippets/ml-compra-rapida.liquid). Misma API de Sense: /cart/add.js con las secciones
   de la notificación; si la página tiene <cart-notification>, se pinta igual que al añadir desde la ficha. Si no, aviso propio. */
(function () {
  function estado(f) {
    var b = f.querySelector('.ml-rapida-btn'); if (!b) return;
    var hayQueElegir = b.dataset.elige === '1', elegida = f.querySelector('input[type=radio]:checked');
    b.textContent = hayQueElegir && !elegida ? 'Elige talla' : 'Añadir al carrito';
    b.setAttribute('aria-disabled', hayQueElegir && !elegida ? 'true' : 'false');
  }
  document.querySelectorAll('.ml-rapida-f').forEach(estado);
  document.addEventListener('change', function (e) { var f = e.target.closest && e.target.closest('.ml-rapida-f'); if (f) estado(f); });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('.ml-rapida-f'); if (!f) return;
    e.preventDefault();
    var b = f.querySelector('.ml-rapida-btn'), aviso = f.querySelector('.ml-rapida-aviso');
    if (b.getAttribute('aria-disabled') === 'true') { var r = f.querySelector('input[type=radio]'); if (r) r.focus(); aviso.textContent = 'Elige una talla.'; return; }
    var cn = document.querySelector('cart-notification');
    var fd = new FormData(f);
    if (cn && cn.getSectionsToRender) { fd.append('sections', cn.getSectionsToRender().map(function (s) { return s.id; })); fd.append('sections_url', location.pathname); cn.setActiveElement && cn.setActiveElement(b); }
    b.disabled = true; b.classList.add('cargando');
    fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status) { aviso.textContent = j.description || j.message || 'No se ha podido añadir.'; b.textContent = 'Agotada'; return; }
        var t = f.querySelector('input[type=radio]:checked');
        aviso.textContent = 'Añadido al carrito: ' + f.dataset.nombre + (t ? ', talla ' + t.dataset.talla : '') + '.';
        if (cn && j.sections) { cn.renderContents(j); }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ml-compra-rapida', productVariantId: fd.get('id'), cartData: j });
        document.dispatchEvent(new CustomEvent('ml:carrito'));
        if (!cn) { b.textContent = 'Añadido'; setTimeout(function () { estado(f); }, 2000); }
      })
      .catch(function () { aviso.textContent = 'No se ha podido añadir. Inténtalo de nuevo.'; })
      .finally(function () { b.disabled = false; b.classList.remove('cargando'); });
  });
})();
